var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract_container"},[_c('offer',{attrs:{"offer":_vm.contract.offer}},[_vm._t("contract_option")],2),_vm._v(" "),_c('div',{staticClass:"subline"},[_c('order',{attrs:{"order":_vm.contract.order}}),_vm._v(" "),_c('agency',{attrs:{"agency":_vm.contract.offer.distributed_product.agency}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac543c18","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Demands/Details/ValidationRequestable/Contract.vue
// module id = 1978
// module chunks = 0